import React, { useEffect, useState } from "react";
import { Tabs, Table, Spin, message, Space, notification } from "antd";
import importIcon from "../../../assets/importIcon.svg";
import "./ProductsStatusTable.css";
import NoDataComponent from "../NoDataComponent";
import AddProductModal from "../AddProductModal";
import { callBackendAPI } from "../../../helpers/apiCalls";
import { LoadingOutlined } from "@ant-design/icons";
import TablePagination from "../../Commons/TablePagination";
import currentAuthenticatedUser from "../../../authUser";
import draftArrow from "../../../assets/draftArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  setOldIdsOfOfMyProducts,
  setPublishFalse,
} from "../../../redux/slices/publish-product-slice";
import CustomLoader from "../../CustomLoader";
import trashbin from "../../../assets/trashbin.svg";
import DeleteProductModal from "./DeleteProductModal";
import { URLS } from "../../../URLS";
import saveIDInLocalStorageOfPublishProduct from "../../../Utilities/saveIDInLocalStorageOfPublishProduct";
import getPublishStatusAndId from "../../../Utilities/getPublishStatusAndId";
import ProductSlotCounterButton from "../ProductSlotCounterButton";

const ProductsStatusTable = ({
  subscriptionStatus,
  importedProductsCount,
  showLimitBar,
  handleCheckSubsCriptionPlan,
}) => {
  const { isPublish, currentEditingProductId, publisPayload } = useSelector(
    (store) => store.publishProduct
  );
  const { shopifyShopDetails } = useSelector((store) => store.authUser);
  const { name: shopName } = shopifyShopDetails || {};

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [productCounts, setproductCounts] = useState({
    all: 0,
    draft: 0,
    active: 0,
  });
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [rowsPerPageNumber, setRowsPerPageNumber] = useState(10);
  const [tab, setTab] = useState({ key: 1, name: "all" });
  const [currentTotal, setCurrentTotal] = useState(10);
  const [loading, setLoading] = useState(true);
  const [authorizationCheckLoading, setAuthorizationCheckLoading] =
    useState(false);
  const [
    authCheckLoadingForEditingProduct,
    setAuthCheckLoadingForEditingProduct,
  ] = useState(false);
  const [publishingId, setPublishingId] = useState();
  const [showtemplates, setShowTemplates] = useState(true);
  const [openDeleteModal, setOpenDeleteModal] = useState({
    open: false,
    productDetails: {},
  });
  // get publishing product details
  useEffect(() => {
    if (products.length > 0) {
      const { status, id } = getPublishStatusAndId();

      setPublishingId(id != "" ? id : products[0]?.product_id);
    }
  }, [products]);

  const handleOldIdsRecord = () => {
    const ids = products.map((p) => p.product_id);

    dispatch(setOldIdsOfOfMyProducts(ids));
  };

  const handleEditProduct = async (id, templateType) => {
    setAuthCheckLoadingForEditingProduct(true);
    saveIDInLocalStorageOfPublishProduct("edit", id);

    try {
      const response = await callBackendAPI(
        "aliexpress/check-access-validity",
        "GET",
        {}
      );

      if (!response?.status) {
        setAuthCheckLoadingForEditingProduct(false);
        openNotification();
      } else {
        setAuthCheckLoadingForEditingProduct(false);
        navigate(`/edit-product/${id}`);
      }
    } catch (error) {
      message.error("Authorization failed", error.message);
    }
  };
  const productTabs = [
    {
      key: "1",
      label: (
        <div className="tab-label-container">
          <div>All products</div>
          <span className="products-number-container">
            {productCounts?.all}
          </span>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="tab-label-container">
          <div>Published </div>
          <span className="products-number-container">
            {productCounts?.active}
          </span>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div className="tab-label-container">
          <div>Draft</div>
          <span className="products-number-container">
            {productCounts?.draft}
          </span>
        </div>
      ),
    },
  ];
  const columns = [
    {
      title: "Product ID",
      dataIndex: "product_id",
      key: "Product ID",
      width: "150px",
    },
    {
      title: "Product Title",
      dataIndex: "product_title",
      key: "Product Title",
      width: "60%",
      render: (text, record) => (
        <div className="product-column-title-container">
          <span className="product-title-image-container">
            <img src={record?.product_image} alt="" />
          </span>
          <>{text}</>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "528.5px",
      render: (status, record) =>
        record.product_id == publishingId && isPublish ? (
          <span className="!flex !justify-center !items-center  !gap-2 !w-[230px] !bg-[#F4F6F7] product-active-status ">
            <CustomLoader width="20px" color="#6941C6" />
            {/*  */}
            <p className="!font-semibold !text-[--primary-color]">
              Uploading product...
            </p>
          </span>
        ) : status === "publish" ? (
          <a
            onClick={() =>
              handleEditProduct(record.product_id, record.templateType)
            }
            className="product-active-status   "
          >
            Published
          </a>
        ) : status === "error_publishing" ? (
          <a
            onClick={() =>
              handleEditProduct(record.product_id, record.templateType)
            }
            className="product-draft-status !text-[white] !w-[230px] !bg-[#d81159]"
          >
            Error when publishing
          </a>
        ) : (
          <a
            onClick={() =>
              handleEditProduct(record.product_id, record.templateType)
            }
            className="product-draft-status"
          >
            Draft
            <span className="product-draft-status-edit">
              Edit <img src={draftArrow} alt="" />
            </span>
          </a>
        ),
    },
    {
      title: "Action",
      key: "action",
      width: "50px",
      render: (status, record) => (
        <span
          onClick={(e) => {
            e.stopPropagation();
            setOpenDeleteModal({ open: true, productDetails: record });
          }}
          className="product-delete-btn"
        >
          <img src={trashbin} alt="" />
        </span>
      ),
    },
  ];
  const onTabChange = (key) => {
    if (key === "1") {
      setTab({ ...tab, key: "1", name: "all" });
    } else if (key === "2") {
      setTab({ ...tab, key: "2", name: "publish" });
    } else if (key === "3") {
      setTab({ ...tab, key: "3", name: "draft" });
    }

    setPaginationNumber(1);
  };
  const [messageApi, contextHolder] = message.useMessage();
  const key = "updateAble";
  console.log("status", subscriptionStatus, importedProductsCount);

  useEffect(() => {
    if (shopName && shopName !== "") {
      if (showLimitBar) {
        if (!isPublish) {
          fetchProducts();
        } else {
          fetchProducts();
          // setTimeout(() => {
          //   publishProduct();
          // }, 3000);

          // Promise.all([
          //   fetchProducts(),
          //   publishProduct()
          // ])
        }
      }
      // setTimeout(() => {
      //   handleCheckSubsCriptionPlan();
      // }, 1000);
    } else {
      setLoading(false);
    }
  }, [tab, paginationNumber, rowsPerPageNumber, shopName, showLimitBar]);
  useEffect(() => {
    if (shopName && shopName !== "") {
      handleCheckSubsCriptionPlan();
    } else {
      setLoading(false);
    }
    
  }, [shopName]);
  useEffect(() => {
    
    if (!loading && isPublish) {
      publishProduct();
    }
  }, [loading]);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };

  // when the product is published
  const publishProduct = async () => {
    // messageApi.open({
    //   key,
    //   type: 'loading',
    //   content: 'Uploading product...',
    //   duration: 100000
    // });
    // // avoid unexpected closing the tab and browser
    // const alertUser = (e) => { e.preventDefault(); e.returnValue = ""; };
    // window.addEventListener("beforeunload", alertUser);

    try {
      const response = await callBackendAPI(
        "template/v1_upload_images_onShopify",
        "POST",
        {},
        {
          payload: publisPayload,
        }
      );

      if (response?.status) {
        messageApi.open({
          key: "success",
          type: "success",
          content: "Successfully uploaded!",
          duration: 4,
        });
      } else {
        messageApi.open({
          key: "error",
          type: "error",
          content: "could not upload!",
          duration: 4,
        });
      }
    } catch (error) {
      messageApi.open({
        key: "error",
        type: "error",
        content: "could not upload!",
        duration: 4,
      });
      console.error("Error:", error);
    } finally {
      window.removeEventListener("beforeunload", alertUser);
      messageApi.destroy(key);
      dispatch(setPublishFalse());
    }
  };
  //saved products fetcher method
  const fetchProducts = async () => {
    if (isPublish) {
      // messageApi.open({
      //   key,
      //   type: 'loading',
      //   content: 'Uploading product...',
      //   duration: 100000
      // });
      // avoid unexpected closing the tab and browser
      window.addEventListener("beforeunload", alertUser);
    }
    setLoading(true);
    setProducts([]);
    const { userId } = await currentAuthenticatedUser();
    try {
      const response = await callBackendAPI(
        "aliexpress/v1_get_saved_products",
        "GET",
        {
          userId: userId,
          shop: shopName,
          status: tab.name,
          page: paginationNumber,
          limit: rowsPerPageNumber,
        }
      );

      if (response?.status) {
        if (tab.name === "all") {
          setCurrentTotal(response?.counts?.all);
        } else if (tab.name === "active") {
          setCurrentTotal(response?.counts?.publish);
        } else if (tab.name === "draft") {
          setCurrentTotal(response?.counts?.draft);
        }
        setproductCounts(response?.counts);

        const newProducts = response?.data?.map((product) => ({
          product_id: product?.id,
          product_title: product?.product_title,
          status: product?.status,
          product_image: product?.product_image,
        }));
        setProducts(newProducts);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      // setRetry(true)
    }
  };
  const handleDeleteProductFrontend = () => {
    const { productDetails } = openDeleteModal;
    setProducts((prev) => {
      const newProducts = prev.filter(
        (p) => p.product_id !== productDetails.product_id
      );
      return newProducts;
    });

    fetchProducts();
    setOpenDeleteModal({ open: false, productDetails: {} });
  };
  const antIcon = (
    <LoadingOutlined
      className="custom-spin-icon"
      style={{ fontSize: "50px" }}
      spin
    />
  );
  const [api, notificationContext] = notification.useNotification();

  const openNotification = () => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <button
          onClick={() => api.destroy()}
          className={`replace-variant-btn  !bg-transparent !border-[--primary-color] !text-[--primary-color]
                disabled:cursor-not-allowed
                 disabled:text-[#f1edf9] 
                 disabled:bg-[#9e75ff] disabled:border-[#9e75ff]
                 h-[ 40px]
                 `}
        >
          Cancel
        </button>
        <button
          onClick={() => {
            reAuthorizeAliExpress();
            api.destroy();
          }}
          className={`replace-variant-btn 
                disabled:cursor-not-allowed
                 disabled:text-[#f1edf9] 
                 disabled:bg-[#9e75ff] disabled:border-[#9e75ff]
                 h-[ 40px]
                 `}
        >
          Authorize again
          <svg
            style={{ transform: "rotate(180deg)" }}
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.5 5L1.5 5M1.5 5L5 8.5M1.5 5L5 1.5"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </Space>
    );
    api.error({
      message: "AliExpress Authorization",
      description: "Please Authorize again!",
      btn,
      key,
      placement: "top",
    });
  };
  // re authorize hanlder
  const reAuthorizeAliExpress = async () => {
    // // for ali express
    const appKey = "506940";
    const callbackUrl = URLS.BACKEND_API + URLS.ALIEXP_CALLBACK_URL;

    // message
    const { userId } = await currentAuthenticatedUser();
    const newUrl = `https://api-sg.aliexpress.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=${callbackUrl}&client_id=${appKey}&state=${userId}`;
    window.location.href = newUrl;
  };
  const handleImportButtonClick = async () => {
    if (loading) {
      message.error("Please wait for the products to load");
      return;
    }

    if (importedProductsCount >= 5 && !subscriptionStatus) {
      window.location.href = "/subscriptions";
      return;
    }

    setAuthorizationCheckLoading(true);
    // handleOldIdsRecord()
    saveIDInLocalStorageOfPublishProduct("importing", "");

    try {
      const response = await callBackendAPI(
        "aliexpress/check-access-validity",
        "GET",
        {}
      );

      if (!response?.status) {
        openNotification();
      } else {
        // message.success('Authorize successfull!')
        setShowAddProductModal(true);
        // here will be the data about templates
        setShowTemplates(true); //this will be set based on the package of the user
      }
    } catch (error) {
      console.error("Error:", error);
      message.error(`Api faied: ${error.message}`);
    } finally {
      setAuthorizationCheckLoading(false);
    }
  };

  return (
    <div className="products-table-main-container">
      {contextHolder}
      {notificationContext}
      {tab && (
        <Tabs defaultActiveKey="1" items={productTabs} onChange={onTabChange} />
      )}

      <div className="import-product-btn-row">
        {shopName &&
        shopName !== "" &&
        showLimitBar &&
        !loading &&
        subscriptionStatus !== null &&
        !subscriptionStatus ? (
          <ProductSlotCounterButton allProductCount={importedProductsCount} />
        ) : (
          <div></div>
        )}
        <button
          className={`${
            !showLimitBar && "cursor-not-allowed"
          } import-product-btn`}
          type="button"
          onClick={handleImportButtonClick}
          disabled={!showLimitBar}
        >
          {authorizationCheckLoading ? "" : "Import product"}
          {authorizationCheckLoading ? (
            <CustomLoader width="20px" color="white" />
          ) : (
            <img src={importIcon} alt="icon" />
          )}
        </button>
      </div>

      <Spin
        indicator={antIcon}
        spinning={loading || authCheckLoadingForEditingProduct}
        style={{ width: "100%" }}
      >
        <div style={{ width: "100%" }}>
          <Table
            onRow={(record) => {
              return {
                onClick: () => {
                  if (
                    currentEditingProductId === record.product_id &&
                    isPublish
                  ) {
                    return;
                  }
                  handleEditProduct(record.product_id);
                },
              };
            }}
            pagination={false}
            style={{ width: "100%" }}
            rowClassName={(record) =>
              record.product_id === currentEditingProductId && isPublish
                ? " !cursor-not-allowed"
                : "table-row"
            }
            columns={columns}
            dataSource={products}
            locale={{
              emptyText: (
                <NoDataComponent
                  authorizationCheckLoading={authorizationCheckLoading}
                  handler={handleImportButtonClick}
                />
              ),
            }}
            rowKey="product_id"
          />

          {currentTotal > 0 ? (
            <TablePagination
              total={currentTotal}
              pageSize={rowsPerPageNumber}
              currentPage={paginationNumber}
              onPageChange={setPaginationNumber}
              onPageSizeChange={setRowsPerPageNumber}
            />
          ) : (
            ""
          )}
        </div>
      </Spin>

      <AddProductModal
        fetchProducts={fetchProducts}
        OpenModal={showAddProductModal}
        setOpModal={setShowAddProductModal}
        handleOldIdsRecord={handleOldIdsRecord}
        showtemplates={showtemplates}
        subscriptionStatus={subscriptionStatus}
      />
      {openDeleteModal?.open && (
        <DeleteProductModal
          handleDeleteFromEnd={handleDeleteProductFrontend}
          OpenModal={openDeleteModal}
          setOpModal={setOpenDeleteModal}
        />
      )}
    </div>
  );
};

export default ProductsStatusTable;
